import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MyApplication } from '../layout.model';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[app-applications-menu]',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <a href="#" (click)="iconClick.emit($event)">
      <i class="topbar-icon fa fa-fw fa-th"></i>
    </a>
    <ul class="layout-menu fadeInDown my-applications">
      <li role="menuitem" *ngFor="let application of applications">
        <a [href]="application.url" target="_blank" rel="noopener noreferrer">
          <img *ngIf="application.icon" [src]="application.icon">
          <p [title]="application.description">{{application.name}}</p>
        </a>
      </li>
    </ul>
  `,
  styles: [`
    .my-applications { margin: 0; padding: 0; width: 300px !important; list-style: none; text-align: center; padding-top: 15px; }
    .my-applications:before { left: 282px !important; }
    .my-applications > li { float: left; width: 33%; height: 110px; }
    .my-applications > li img { width: 50px; height: 50px; }
    .my-applications > li p { margin: 0px; }
  `]
})
export class ApplicationsMenuComponent {
  @Input() applications: MyApplication[] = [];
  @Output() iconClick = new EventEmitter();
}
